import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobeAmericas } from 'react-icons/fa';
import './StrategicObjectives.scss';

const StrategicObjectives = () => {
  const { t } = useTranslation();

  return (
    <div className="hsv-strategic-diagram">
      <div className="hsv-strategic-diagram__header">
        <h2>{t("strategic_objectives.title")}</h2>
        <div className="hsv-strategic-diagram__header-lines">
          <div className="line-green"></div>
          <div className="line-blue"></div>
        </div>
      </div>
      
      <div className="hsv-strategic-diagram__body">
        {/* Left Column */}
        <div className="hsv-strategic-diagram__column left-col">
          <div className="hsv-strategic-diagram__section">
            <h3 className="hsv-strategic-diagram__section-title text-green">
              {t("strategic_objectives.left.section1_title")}
            </h3>
            <ul className="hsv-strategic-diagram__list">
              <li>{t("strategic_objectives.left.section1_item1")}</li>
            </ul>
          </div>
          
          <div className="hsv-strategic-diagram__section">
            <h3 className="hsv-strategic-diagram__section-title text-green">
              {t("strategic_objectives.left.section2_title")}
            </h3>
            <ul className="hsv-strategic-diagram__list">
              <li>{t("strategic_objectives.left.section2_item1")}</li>
              <li>{t("strategic_objectives.left.section2_item2")}</li>
            </ul>
          </div>
        </div>

        {/* Center Vertical Divider */}
        <div className="hsv-strategic-diagram__center">
          <div className="center-top bg-green">
            {t("strategic_objectives.center.top").split("").map((letter, i) => <span key={i}>{letter}</span>)}
          </div>
          <div className="center-globe">
            <div className="globe-icon"></div>
          </div>
          <div className="center-bottom bg-blue">
            {t("strategic_objectives.center.bottom").split("").map((letter, i) => <span key={i}>{letter}</span>)}
          </div>
        </div>

        {/* Right Column */}
        <div className="hsv-strategic-diagram__column right-col">
          <div className="hsv-strategic-diagram__section">
            <h3 className="hsv-strategic-diagram__section-title text-green">
              {t("strategic_objectives.right.section1_title")}
            </h3>
            <ul className="hsv-strategic-diagram__list">
              <li>{t("strategic_objectives.right.section1_item1")}</li>
              <li>{t("strategic_objectives.right.section1_item2")}</li>
            </ul>
          </div>

          <div className="hsv-strategic-diagram__section">
            <h3 className="hsv-strategic-diagram__section-title text-green">
              {t("strategic_objectives.right.section2_title")}
            </h3>
            <ul className="hsv-strategic-diagram__list">
              <li>{t("strategic_objectives.right.section2_item1")}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrategicObjectives;
